import React from "react";
import "../../assets/styles/styles.less";
import "./styles.less";
import texts from "../../assets/strings/select";
import CharityCard from "./CharityCard";
import descriptions from "../../assets/strings/charities";

const SelectCharityDesktop = props => (
  <div className="selectCharity desktop">
    <div style={{ padding: "8px" }}>
      <h1>{texts.h1}</h1>
      <h3 className="areaTitle">{texts.h3}</h3>
      <p className="note">{texts.note}</p>
    </div>
    <div className="charities-list">
      {props.reducer.featuredCharities.map((charity, idx) => (
        <CharityCard
          key={`charity-${idx}`}
          charity={charity}
          description={descriptions[charity.ein]}
          onClick={props.selectCharity}
          showActions={true}
          isResponse={props.details.isResponse}
        />
      ))}
    </div>
  </div>
);

export default SelectCharityDesktop;



// WEBPACK FOOTER //
// ./components/SelectCharity/SelectCharityDesktop.js